<!--
 * Created by JackCui on 2021/3/30
 -->
<template>
  <div class="sy-filter-boole">
    <el-select
      v-model="valueData"
      v-on="$listeners"
      v-bind="{...$props, ...$attrs}"
      clearable
      :placeholder="field.placeholder"
      style="width: 100%;"
    >
      <el-option
        v-for="item in choiceValues"
        :key="item.choiceValue.choiceKey"
        :label="item.choiceValue.value"
        :value="item.choiceValue.choiceKey"
      />
    </el-select>
  </div>
</template>

<script>
  export default {
    name: 'filter-boole',
    model: {
      event: 'change',
      prop: 'value'
    },
    props: {
      value: {
        type: String
      },
      field: {
        type: Object
      }
    },
    watch: {
      value: {
        handler (newVal) {
          if (newVal && newVal.toString) {
            this.valueData = newVal.toString()
          }
        },
        immediate: true
      }
    },
    data () {
      return {
        valueData: ''
      }
    },
    computed: {
      choiceValues () {
        if (this.field.uiComponent === 2) {
          return [{
            choiceValue: {
              value: '否',
              choiceKey: 'false'
            }
          }, {
            choiceValue: {
              value: '是',
              choiceKey: 'true'
            }
          }]
        }
        return this.field.choiceValues.filter(item => {
          return !item.state
        })
      }
    }
  }
</script>
